import { IPivotProps, Pivot } from '@fluentui/react/lib/Pivot';

export interface IPPivotProps extends IPivotProps {}

export const IPPivot = (props: IPPivotProps) => {
  return <Pivot {...props} />;
};
